import React from "react";
import { FOOTER } from "../../../layout/kor/footer";
import { SUBHEADER } from "../../../layout/kor/subheader";
import { Products } from "../../../parts/kor/business/products";
export const PRODUCTS = () => {
  return (
    <main id="content">
      <SUBHEADER />
      <div id="business">
        <Products />
      </div>
      <FOOTER />
    </main>
  );
};
